// extracted by mini-css-extract-plugin
export default {"deleteIcon":"styles_deleteIcon__QmluD"};